import { useIntl } from 'react-intl';

import AgInfoCard from '../../stories/Components/Cards/AgInfoCard';

import * as S from './styled';

export type AgNoPermissionProps = { noPadding?: boolean };

const AgNoPermission = ({ noPadding }: AgNoPermissionProps) => {
  const { formatMessage } = useIntl();

  return (
    <S.Main noPadding={noPadding}>
      <AgInfoCard
        title={formatMessage({ id: 'GENERIC_NO_PERMISSION_TITLE' })}
        message={formatMessage({ id: 'GENERIC_NO_PERMISSION_DESC' })} 
        closeIcon={false} 
        width='560px'
      />
    </S.Main>
  );
};

export default AgNoPermission;